<script>
import LongFormContent from '../../../components/dynamicContentTypes/LongFormContent.vue';

export default {
  name: 'EditorsChoiceAwardIntroImage',
  components: {
    LongFormContent,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    baseClassName: 'ea-editors-choice-award-methodology',
  }),
  computed: {
  },
  methods: {
  },
};
</script>

<template>
  <section :class="`${baseClassName}`">
    <long-form-content
      :class="`${baseClassName}_text`"
      :json-content="content"
    />
  </section>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

$baseClassName: 'ea-editors-choice-award-methodology';

.#{$baseClassName} {
  margin: 0;
  padding: 0;
  @include cdr-xs-mq-up {
    padding: 0 $cdr-space-two-x $cdr-space-one-x $cdr-space-two-x;
  }
  @include cdr-sm-mq-up {
    padding: 0 $cdr-space-three-x $cdr-space-two-x $cdr-space-three-x;
  }
  @include cdr-lg-mq-up {
    margin-bottom: $cdr-space-four-x;
    padding: 0 $cdr-space-one-x $cdr-space-two-x $cdr-space-one-x;
  }
}
.#{$baseClassName}_text {
  @include cdr-text-body-300;
  margin-top: $cdr-space-one-and-a-half-x;
}

</style>
